/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForDiscoverSkeleton.defs'
export { main as default } from './getSuggestedUsersForDiscoverSkeleton.defs'
